<template>
  <div class="res-container">
    <img src="../assets/zan.png" alt="赞图" class="suppont-image">
    <div class="content-wrapper">
      <div class="completion-text">答题完成</div>
      
      <div class="score-container">
        <div class="score-text">{{ score }}分</div>
      </div>
      <div class="text-container">
<p>中华民族一家亲</p>
<p>同心共筑中国梦</p>
<p>各族儿女手挽着手、肩并着肩</p>
<p>一起共创中华民族的美好未来</p>
<p>一起共享民族复兴的伟大荣光</p>
      </div>
      <div class="button-group">
        <div class="retry-button" @click="retryQuiz">再答一次</div>
        <div class="share-button" @click="shareResult">点击分享</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router'
import { ref, computed, onUnmounted } from 'vue'

const router = useRouter()
const route = useRoute()

// 获取从 QuestionView 传递过来的分数参数
const score = computed(() => {
  return route.query.score || 0
})

// 根据分数动态生成分享文本
const shareText = computed(() => {
  return `我在民宗测试挑战中获得了${score.value}分的好成绩！`
})

const retryQuiz = () => {
  router.push('/question')
}

// 组件卸载时清理分享图片
onUnmounted(() => {
  // 查找并移除可能存在的分享覆盖层
  const existingOverlay = document.querySelector('[data-share-overlay]');
  if (existingOverlay && document.contains(existingOverlay)) {
    document.body.removeChild(existingOverlay);
  }
});

// 备用分享方法

const shareResult = () => {
  // 先移除可能已存在的分享覆盖层
  const existingOverlay = document.querySelector('[data-share-overlay]');
  if (existingOverlay && document.contains(existingOverlay)) {
    document.body.removeChild(existingOverlay);
    return; // 如果存在则先关闭，不再重复创建
  }

  // 创建全屏黑色背景
  const overlay = document.createElement('div');
  overlay.setAttribute('data-share-overlay', 'true'); // 添加标识属性
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100vw';
  overlay.style.height = '100vh';
  overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
  overlay.style.zIndex = '9999';
  overlay.style.display = 'flex';
  overlay.style.justifyContent = 'flex-end';
  overlay.style.alignItems = 'flex-start';
  overlay.style.padding = '20px';

  // 创建分享图片
  const shareImg = document.createElement('img');
  shareImg.src = require('../assets/share.png');
  shareImg.alt = '分享图';
  shareImg.style.maxWidth = '200px';
  shareImg.style.maxHeight = '200px';
  shareImg.style.width = '100px'; // 设置分享图片大小为100px
  shareImg.style.height = 'auto';
  shareImg.style.marginRight = '40px'; // 右上角20px
  shareImg.style.marginTop = '0px';   // 右上角20px

  overlay.appendChild(shareImg);
  document.body.appendChild(overlay);

  // 点击背景关闭
  overlay.addEventListener('click', () => {
    document.body.removeChild(overlay);
  });
}


</script>

<style lang="scss" scoped>
.res-container {
  background-image: url('../assets/quebg.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 90px; /* 顶部间距 */
  box-sizing: border-box;
}

.suppont-image {
	width: 255px;
	height: 225px;
  margin-bottom: 40px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 800px;
  padding: 0 20px;
}

.completion-text {
	font-family: FZLTHK--GBK1-0;
	font-size: 34px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 36px;
	letter-spacing: 0px;
	color: #fff1c2;
  text-align: center;
  margin-bottom: 20px;
}

.score-text {
	font-family: FZLTCHK--GBK1-0;
	font-size: 84px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 36px;
	letter-spacing: 4px;
	color: #ed3417;
}

.score-container {
  width: 455px;
	height: 226px;
  background-image: url('../assets/score.png');
  background-size: 100% 100%; /* 使用 100% 100% 确保背景随容器拉伸 */
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 48px;
  box-sizing: border-box;

}

.score-divider {
  flex: 1;
  height: 4px;
  background-color: #f8d8a4;
}

.score-text-inline {
  padding: 0 20px;
  font-family: SourceHanSansCN-Regular;
  font-size: 40px;
  font-weight: bold;
  color: #f8d8a4;
  text-align: center;
  white-space: nowrap;
}

.button-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 42px; /* 按钮之间的间距 */
  width: 100%;
  width: 317px;
  margin-top: 20px; /* 将按钮组推到底部 */
}

.retry-button, .share-button {
	width: 317px;
	height: 68px;
	background-image: linear-gradient(0deg, 
		#f4cd2d 0%, 
		#ffeaad 100%);
	border-radius: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

	font-family: MicrosoftYaHei-Bold;
	font-size: 34px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 36px;
	letter-spacing: 3px;
	color: #d7461e;

}

.text-container {
  width: 380px;
  min-height: 235px;
  background-color: rgba(255, 237, 200, 0.0);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: FZLTHK--GBK1-0;
  font-size: 28px;
  font-weight: normal;
  line-height: 52px;
  color: #ffffff;
  text-align: center;
}

.text-container p {
  margin: 0;
  text-align: center;
}


.retry-button {
  background-color: #f6df91;
  color: #b51608;
}

.share-button {
  	background-image: linear-gradient(0deg, 
		#ee4f01 1%, 
		#ff8042 100%);
  color: #ffffff;
}

.retry-button:hover, .share-button:hover {
  transform: scale(1.05);
}

.retry-button:active, .share-button:active {
  transform: scale(0.98);
}
</style>